import { CustomerAddress } from "./customer-address";
import { Unity } from "./unity";
import { Expense } from "./expense";
import { Customer } from "./customer";

export class TravelRoute {
    id:number = 0;
    name:string = '';
    source_customer_address_id:number = 0;
    source_customer_address:CustomerAddress = new CustomerAddress();
    source_customer:Customer = new Customer();
    target_customer_address_id:number = 0;
    target_customer_address:CustomerAddress = new CustomerAddress();
    target_customer:Customer = new Customer();
    meters:number = 0;
    time:number = 0;
    expenses:any[] = [];
    gas:number = 0;
}
